import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appPhone]',
    standalone: true
})
export class PhoneDirective {
	constructor(public model: NgControl) {}

	@HostListener('keyup', ['$event']) onKeyup($event: any) {
		this.formatPhoneValue($event);
	}

	@HostListener('paste', ['$event']) onPaste($event: any) {
		this.formatPhoneValue($event);
	}

	formatPhoneValue(event: any) {
		event.preventDefault();

		let text = '';

		if (event.type === 'paste') {
			text = event.clipboardData.getData('Text');
		} else {
			text = event.target.value;
		}

		let newVal = text.replace(/[^0-9]/g, '');

		let areaCode: string, number: string;

		if (!newVal) {
			newVal = '';
		} else {
			if (newVal[0] === '0' || newVal[0] === '1') {
				newVal = newVal.slice(1, newVal.length);
			}

			switch (newVal.length) {
				case 1:
				case 2:
				case 3:
					areaCode = newVal;
					break;
				default:
					areaCode = newVal.slice(0, 3);
					number = newVal.slice(3);
			}
			if (number) {
				if (number.length > 3) {
					number = number.slice(0, 3) + '-' + number.slice(3, 7);
				} else {
					number = number;
				}
				newVal = ('(' + areaCode + ') ' + number).trim();
			} else {
				newVal = '(' + areaCode;
			}
		}
		// set the new value
		// TODO: Look into limiting the state change firing so much
		this.model.control.setValue(newVal);
		// this.model.control.updateValueAndValidity();
	}
}
